/**
 * The enumeration of bidirectional text layout types.
 */
export enum BiDi {

  /**
   * Left to right.
   */
  LTR = 'ltr',

  /**
   * Right to left.
   */
  RTL = 'rtl',
}
